(function () {
	document.addEventListener("DOMContentLoaded", () => {
		document.addEventListener("click", (event) => {
			const item = event.target.closest("li");
			if (!item) return;

			if (handlePrimaryMenu(item)) return;

			if (handleSecondaryMenu(item)) return;
		});

		function handlePrimaryMenu(item) {
			if (!item || !item.classList.contains("site-header__nav-item")) return false;

			const link = item.querySelector("a");

			let event_detail = VgGtm.formatGtmLabel(link.textContent);
			let event_label = VgGtm.formatGtmLabel(link.textContent);

			if (item.classList.contains("site-header__nav-item--subscribe")) {
				event_detail = 'cta';
				event_label = 'inscribete';
			}

			if (item.classList.contains("site-header__nav-item--account")) {
				event_detail = 'area_de_cliente';
				event_label = 'area_de_cliente';
			}

			VgGtm.pushRegisterEventToDataLayer(
				'click',
				{},
				{ 
					event_category: 'menu',
					event_detail:event_detail,
					event_label:event_label,
				}
			);

			return true;
		}

		function handleSecondaryMenu(item) {
			if (!item || !item.classList.contains("site-header__subnav-item")) return false;

			const link = item.querySelector("a");
			const parentLi = item.closest("ul").closest("li");
			const parentLink = parentLi.querySelector("a");

			let event_detail = VgGtm.formatGtmLabel(parentLink.textContent);
			let event_label = VgGtm.formatGtmLabel(link.textContent);

			VgGtm.pushRegisterEventToDataLayer(
				'click',
				{},
				{ 
					event_category: 'menu',
					event_detail:event_detail,
					event_label:event_label,
				}
			);
			
			return true;
		}
	});
})();